export const columnNamesSelector = (state) => state.partners.columnNames;
export const dataGridSelector = (state) => state.partners.dataGrid;
export const dataGridLoaderSelector = (state) => state.partners.dataGridLoader;
export const selectedPartnerSelector = (state) => state.partners.selectedPartnerRow;
export const fichePartnerFormSelector = (state) => state.partners.fichePartnerForm;
export const loaderfichePartnerSelector = (state) => state.partners.fichePartnerLoader;
export const partnerSuiviSelector = (state) => state.partners.partnerSuivi;
